import { MomentDateAdapter, } from "@angular/material-moment-adapter";
import { LOCALE_ID, Injectable, Inject } from "@angular/core";
import { DateAdapter } from "@angular/material/core";

import * as firebase from "firebase/app";
import "firebase/firestore";

import * as moment from 'moment';


@Injectable()
export class FirestoreTimestampMomentDateAdapter extends DateAdapter<firebase.firestore.Timestamp> {

  private adapter: MomentDateAdapter;

  constructor(@Inject(LOCALE_ID) localeId) {
    super();
    this.adapter = new MomentDateAdapter(localeId);
  }

  _toMoment(date: firebase.firestore.Timestamp): moment.Moment {
    return date ? moment(date.toDate()) : null;
  }

  _toTimestamp(date: moment.Moment): firebase.firestore.Timestamp {
    return date ? firebase.firestore.Timestamp.fromDate(date.toDate()) : null;
  }

  getYear(date: firebase.firestore.Timestamp): number {
    return this.adapter.getYear(this._toMoment(date));
  };
  getMonth(date: firebase.firestore.Timestamp): number {
    return this.adapter.getMonth(this._toMoment(date));
  }
  getDate(date: firebase.firestore.Timestamp): number {
    return this.adapter.getDate(this._toMoment(date));
  }
  getDayOfWeek(date: firebase.firestore.Timestamp): number {
    return this.adapter.getDayOfWeek(this._toMoment(date));
  }
  getMonthNames(style: "long" | "short" | "narrow"): string[] {
    return this.adapter.getMonthNames(style);
  }
  getDateNames(): string[] {
    return this.adapter.getDateNames();
  }
  getDayOfWeekNames(style: "long" | "short" | "narrow"): string[] {
    return this.adapter.getDayOfWeekNames(style);
  }
  getYearName(date: firebase.firestore.Timestamp): string {
    return this.adapter.getYearName(this._toMoment(date));
  }
  getFirstDayOfWeek(): number {
    return this.adapter.getFirstDayOfWeek();
  }
  getNumDaysInMonth(date: firebase.firestore.Timestamp): number {
    return this.adapter.getNumDaysInMonth(this._toMoment(date));
  }
  clone(date: firebase.firestore.Timestamp): firebase.firestore.Timestamp {
    return this._toTimestamp(this.adapter.clone(this._toMoment(date)));
  }
  createDate(year: number, month: number, date: number): firebase.firestore.Timestamp {
    return this._toTimestamp(this.adapter.createDate(year, month, date));
  }
  today(): firebase.firestore.Timestamp {
    return this._toTimestamp(this.adapter.today());
  }
  parse(value: any, parseFormat: any): firebase.firestore.Timestamp {
    return this._toTimestamp(this.adapter.parse(value, parseFormat));
  }
  format(date: firebase.firestore.Timestamp, displayFormat: any): string {
    return this.adapter.format(this._toMoment(date), displayFormat);
  }
  addCalendarYears(date: firebase.firestore.Timestamp, years: number): firebase.firestore.Timestamp {
    return this._toTimestamp(this.adapter.addCalendarYears(this._toMoment(date), years));
  }
  addCalendarMonths(date: firebase.firestore.Timestamp, months: number): firebase.firestore.Timestamp {
    return this._toTimestamp(this.adapter.addCalendarMonths(this._toMoment(date), months));
  }
  addCalendarDays(date: firebase.firestore.Timestamp, days: number): firebase.firestore.Timestamp {
    return this._toTimestamp(this.adapter.addCalendarDays(this._toMoment(date), days));
  }
  toIso8601(date: firebase.firestore.Timestamp): string {
    return this.adapter.toIso8601(this._toMoment(date));
  }
  isDateInstance(obj: any): boolean {
    return obj instanceof firebase.firestore.Timestamp;
  }
  isValid(date: firebase.firestore.Timestamp): boolean {
    return date !== null; // TODO: emulare comportamento di moment
  }
  invalid(): firebase.firestore.Timestamp {
    return null;  // TODO: emulare comportamento di moment
  }

}
